// tslint:disable-next-line:no-reference
/// <reference path="../HTML/Span.ts" />
namespace HA.Core.Notification {
    import Tag = HA.Core.HTML.Tag;
    import Span = HA.Core.HTML.Span;
    import Div = HA.Core.HTML.Div;

    export class NotificationEntry extends Tag {
        public show() {
            super.show();
            this.addToData("interval", timeout(() => {
                this.end();
            }, this.get("d") || 3000));
            this.onClick(() => {
                this.end();
            });
        }

        public hide() {
            super.hide("table");
        }

        public pause() {
        }

        public end() {
            clearTimeout(this.get("interval"));
            this.get("end")();
        }

        protected createSelf() {
            const item = new Div();
            item.setAttribute("data-nosnippet", '');
            const m = this.get("m");
            let mtext = "";
            if (m instanceof Map || m instanceof Array) {
                m.forEach((e: any) => {
                    mtext += e;
                });
            } else {
                mtext = m;
            }
            item.appendChild(new Span(mtext));
            this.setElement(item.getElement(true));
        }

        protected initialize(data?: any): void {
            super.initialize(data);
            const a = this.get("a");
            if (a) {
                this.onClick(() => {
                    getAppService().processAction(toMap(a));
                });
            }
        }
    }
}
